import Typography from 'components/Typography/Typography';

import { SubscriptionsTable } from './components/SubscriptionsTable';

const Subscriptions = () => {
  return (
    <div className="opacity-100 pointer-events-auto">
      <div className="px-7 pt-8 mb-5">
        <div className="flex justify-between items-center min-h-10">
          <Typography className="text-hd-h3">Subscriptions List</Typography>
        </div>
      </div>

      <div className="px-9 pb-9 pt-2.5">
        <SubscriptionsTable />
      </div>
    </div>
  );
};

export default Subscriptions;
